<template>
  <div>
    <v-row justify="center">
      <v-dialog class="modal_medium" v-model="visible" persistent>
        <v-card>
          <v-form
            ref="form"
            v-model="valid"
            method="post"
            enctype="multipart/form-data"
            lazy-validation
          >
            <v-card-title>
              <span class="headl">NUEVA ESTACIÓN</span>
            </v-card-title>
            <v-card-text>
            <!--  <v-container>
                <v-row>
                  <v-col >
                     <v-btn style="position: relative; width: 100%">Domoticz</v-btn>
                 </v-col>
                  <v-col>
                     <v-btn style="position: relative; width: 100%">MQTT broker</v-btn>
                  </v-col>
              </v-row> 
              </v-container> -->
              <v-container>
                <v-row> 
                  <v-col>
                    <v-select
                      ref="activate"
                      v-model="form.type"
                      :items="['Domoticz','Broker']"
                      item-value="id"
                      item-text="name"
                      label="Tipo"
                      :rules="fieldRules"
                    ></v-select>
                  </v-col> 
                </v-row>
                <v-row>        
                  <v-col cols="12" sm="6" md="6" >
                    <v-text-field
                      ref="name"
                      v-model="form.nameStation"
                      :rules="nameRules"
                      label="Nombre"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-select
                      ref="activate"
                      v-model="form.activate"
                      :items="[
                        { id: '1', name: 'Activo' },
                        { id: '0', name: 'Inactivo' },
                      ]"
                      item-value="id"
                      item-text="name"
                      label="Estado"
                      :rules="fieldRules"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="lat"
                      v-model="form.lat"
                      label="Latitud"
                      placeholder="Ej: -24.xxxxxx"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="lon"
                      v-model="form.lon"
                      label="Longitud"
                      placeholder="Ej: -24.xxxxxx"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="3" md="3">
                    <v-text-field
                      ref="Protocol"
                      label="Protocol"
                      :value = placeholderText
                      :disabled= true
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="ipRemote"
                      v-model="originalValues.ipRemote"
                      label="IP"
                      placeholder="Ej: xx.xxx.xxx"
                      :rules="nameRules"
                      required
                    ></v-text-field>
                  </v-col>
                  
                  <v-col cols="12" sm="2" md="2">
                    <v-text-field
                      ref="port"
                      v-model="form.port"
                      label="Puerto"
                      placeholder="80xx"
                      :rules="nameRules"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="userGateway"
                      v-model="form.userGateway"
                      label="Usuario"  
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="passwordGateway"
                      v-model="form.passwordGateway"
                      label="Contraseña"    
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6" v-if="form.type === 'Broker'">
                    <v-text-field
                      ref="topic"
                      placeholder="Ej: topic/sub-topic"
                      v-model="form.topic"
                      label="Topico"
                      :rules="fieldRules"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="city"
                      v-model="form.city"
                      label="Ciudad"
                      :rules="fieldRules"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="ctn_btn_shop">
                <v-btn large text @click.stop="show = false">Cerrar</v-btn>
                <v-btn
                  :disabled="!valid"
                  depressed
                  large
                  color="primary"
                  @click="validate"
                  >GUARDAR</v-btn
                >
              </div>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "CompanyNewComp",
  components: {},
  props: ["visible"],
  data() {
    return {
      form: {
        type: 'Domoticz',
        nameStation: null,
        lat: null,
        lon: null,
        ipRemote: null,
        port: null,
        userGateway: null,
        passwordGateway: null,
        topic: null,
        city: null,
        activate: null,
      },
      originalValues: {
      protocol: null,
      ipRemote: null
    },
      valid: true,
      serviceRule: [(v) => !!v || "El campo es requerido"],
      nameRules: [(v) => !!v || "El campo es requerido"],
      fieldRules: [(v) => !!v || "El campo es requerido"],
    };
  },
  mounted() {  
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.$refs.form.reset();
        this.$emit("close");
        // Or any other way you want to close your modal
      }
    });
  },
  methods: {
    ...mapActions(["addStation", "alertSnackbar"]),

    resetForm(){
       this.form.nameStation = '';
       this.form.lat  = '';
       this.form.lon = '';
       this.form.ipRemote = '';
       this.form.userGateway = '';
       this.form.passwordGateway = '';
       this.form.topic = '',
       this.form.city = '';
       this.form.activate = '';
    },
    
    updateProtocol() { 
      this.form.ipRemote = `${this.placeholderText}${this.originalValues.ipRemote}`;
    },

    validate() {
      if (this.$refs.form.validate()) {
        this.registerForm();
      }
    },
    async registerForm() {
      try {

       await this.updateProtocol()
        let newData = await this.addStation(this.form);
        this.resetForm()
        this.show = false;
        if (newData == 200) {
          this.$root.$emit("reload"); // parametro update tabla
          this.alertSnackbar({
            snackbar: true,
            text: "La Gateway o Estación se ha creado.",
          });
        } else {
          //error 500
          this.alertSnackbar({
            snackbar: true,
            text: "ocurrio un error con el servidor.",
          });
        }
      } catch (error) {
        //console.log(error);
        this.alertSnackbar({
          snackbar: true,
          text: "ocurrio un error con el servidor.",
        });
      }
    },
  },
  computed: {
    placeholderText() {
      // Determina el marcador de posición según el valor seleccionado en el v-select
      if (this.form.type === 'Domoticz') {
        return 'http://';
      } else {
        return 'mqtt://'; 
      }
    },
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) { 
          this.resetForm()
          this.$emit("close");
        }
      },
    },
  },
};
</script>
<style lang="scss" scope>
@import "../../assets/scss/base.scss";
</style>
